import { render, staticRenderFns } from "./TxListManage.vue?vue&type=template&id=2dd66ba0&scoped=true"
import script from "./TxListManage.vue?vue&type=script&lang=js"
export * from "./TxListManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd66ba0",
  null
  
)

export default component.exports